import request from './request'
function getShareConfig() {
    var url = window.location.href
    var data = { appId: 'wx063a6dce281e92b1', url: url }
    return request('get','/qxapi/edu/wechat/shareconfig', data)
}

export default {
    getShareConfig
}
